import { useEffect } from "react";

// Module-level ref count so nested/simultaneous overlays share one lock and only
// the last one to close restores the page — avoids one modal prematurely undoing
// another's freeze.
let lockCount = 0;
let savedScrollY = 0;
let savedStyles = null;

function engage() {
  lockCount += 1;
  if (lockCount > 1) return; // already locked by an outer overlay
  savedScrollY = window.scrollY;
  const b = document.body;
  savedStyles = {
    position: b.style.position,
    top: b.style.top,
    left: b.style.left,
    right: b.style.right,
    width: b.style.width,
    overflow: b.style.overflow,
  };
  b.style.position = "fixed";
  b.style.top = `-${savedScrollY}px`;
  b.style.left = "0";
  b.style.right = "0";
  b.style.width = "100%";
  b.style.overflow = "hidden";
}

function release() {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount > 0 || !savedStyles) return; // other overlays still open
  const b = document.body;
  b.style.position = savedStyles.position;
  b.style.top = savedStyles.top;
  b.style.left = savedStyles.left;
  b.style.right = savedStyles.right;
  b.style.width = savedStyles.width;
  b.style.overflow = savedStyles.overflow;
  savedStyles = null;
  window.scrollTo(0, savedScrollY);
}

// Freezes the background page while an overlay/modal is open and restores the exact
// scroll position when the last lock is released.
export function useScrollLock(locked) {
  useEffect(() => {
    if (!locked) return;
    engage();
    return release;
  }, [locked]);
}
